import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Popover, TextField } from 'wix-ui-tpa/cssVars';
import { useFocus } from '../../../hooks/use-focus';
import { CountryList } from './country-list';
import { FlagButton } from './flag-button';
import { getCallingCode, replaceCallingCode, parseLongCountryCode } from './phone-input-utils';
import { classes } from './phone-input.st.css';
const MOVE_POPOVER_BY = {
  y: 0
};
export const PhoneInput = _ref => {
  let {
    id,
    value,
    placeholder,
    disabled,
    required,
    hasError,
    ariaDescribedBy,
    ariaInvalid,
    className,
    theme,
    onChange,
    onFocus,
    onBlur
  } = _ref;
  const phoneInputRef = useRef(null);
  const flagButtonRef = useRef(null);
  const popoverRef = useRef(null);
  const [popoverShown, setPopoverShown] = React.useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState();
  const parsedCountryCode = parseLongCountryCode(value);
  const longCountryCode = selectedCountryCode ?? parsedCountryCode;
  useEffect(() => {
    if (getCallingCode(parsedCountryCode) !== getCallingCode(selectedCountryCode)) {
      setSelectedCountryCode(parsedCountryCode);
    }
  }, [selectedCountryCode, parsedCountryCode]);
  useEffect(() => {
    const handleClickOutside = event => {
      var _flagButtonRef$curren;
      if (!(event.target instanceof Node)) {
        return;
      }
      const flagButton = (_flagButtonRef$curren = flagButtonRef.current) == null || (_flagButtonRef$curren = _flagButtonRef$curren.wrappedComponentRef) == null ? void 0 : _flagButtonRef$curren.innerComponentRef;
      const isOutsideFlagButton = Boolean(flagButton && !flagButton.contains(event.target));
      const isOutsidePopover = Boolean(popoverRef.current && !popoverRef.current.contains(event.target));
      if (isOutsideFlagButton && isOutsidePopover) {
        setPopoverShown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleFlagClick = useCallback(() => setPopoverShown(previousValue => !previousValue), []);
  const handleFlagKeyDown = useCallback(event => {
    if (popoverShown) {
      return;
    }
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Enter':
      case ' ':
        event.preventDefault();
        setPopoverShown(true);
        break;
    }
  }, [popoverShown]);
  const handlePopoverKeyDown = useCallback(event => {
    var _phoneInputRef$curren, _flagButtonRef$curren2;
    if (!popoverShown) {
      return;
    }
    switch (event.key) {
      case 'Tab':
        event.preventDefault();
        setPopoverShown(false);
        (_phoneInputRef$curren = phoneInputRef.current) == null || _phoneInputRef$curren.focus();
        break;
      case 'Escape':
        event.preventDefault();
        setPopoverShown(false);
        (_flagButtonRef$curren2 = flagButtonRef.current) == null || _flagButtonRef$curren2.focus();
        break;
    }
  }, [popoverShown]);
  const handleSelectionChange = useCallback(countryCode => {
    var _phoneInputRef$curren2;
    setSelectedCountryCode(countryCode);
    const callingCode = getCallingCode(countryCode);
    if (callingCode) {
      const phoneNumber = replaceCallingCode(value, callingCode);
      onChange(phoneNumber);
    }
    setPopoverShown(false);
    (_phoneInputRef$curren2 = phoneInputRef.current) == null || _phoneInputRef$curren2.focus();
  }, [onChange, value]);
  const handlePhoneInputChange = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);
  const {
    containerRef,
    handleBlur,
    handleFocus
  } = useFocus({
    onBlur,
    onFocus
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    onBlur: handleBlur,
    onFocus: handleFocus
  }, /*#__PURE__*/React.createElement(Popover, {
    className: classes.popover,
    shown: popoverShown,
    placement: "auto-start",
    moveBy: MOVE_POPOVER_BY,
    fluid: true,
    showArrow: false
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(TextField, {
    ref: phoneInputRef,
    id: id,
    type: "phone",
    error: hasError,
    newErrorMessage: true,
    value: typeof value === 'string' ? value : '',
    className: className,
    required: required,
    disabled: disabled,
    placeholder: placeholder,
    theme: theme,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": ariaInvalid,
    onChange: handlePhoneInputChange,
    prefix: /*#__PURE__*/React.createElement(FlagButton, {
      ref: flagButtonRef,
      chevronDirection: popoverShown ? 'up' : 'down',
      longCountryCode: longCountryCode,
      onClick: handleFlagClick,
      onKeyDown: handleFlagKeyDown
    })
  })), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement("div", {
    ref: popoverRef,
    onKeyDown: handlePopoverKeyDown
  }, /*#__PURE__*/React.createElement(CountryList, {
    selectedCountry: longCountryCode,
    onSelectionChange: handleSelectionChange
  })))));
};
//# sourceMappingURL=phone-input.js.map